import { giganttitheme } from '@jotta/ui/themes/gigantti'
import { startApp } from '../App'

startApp(giganttitheme)
